import type { LoanTerm } from './types/LoanTerm';

export const loanTermArray: LoanTerm[] = ['24', '36', '48', '60', '72', '84'];
